export default "__VITE_ASSET__SIX5DgZO__"